import SpinIcon from '@repo/ui/src/components/Icons/SpinIcon';
import { classNames } from '@repo/ui/src/utils/classNames';

interface Props {
  dark?: boolean;
  onClick?: () => void;
}

const SpinIndicator = ({ dark, onClick }: Props) => {
  const Component = onClick ? 'button' : 'div';

  return (
    <Component
      className={classNames('grid grid-flow-col gap-3', onClick && 'group')}
      onClick={onClick}
    >
      <div
        className={classNames(
          'flex items-center mr-2 w-5 md:w-6',
          dark
            ? 'text-neutral-100 group-hover:text-neutral-200 group-focus:text-neutral-200'
            : 'text-warm-500 group-hover:text-neutral-300',
        )}
      >
        <SpinIcon aria-hidden="true" />
      </div>
      <p
        className={classNames(
          'tra-text-web-body-l font-bold',
          dark
            ? 'text-neutral-100 group-hover:text-neutral-200 group-focus:text-neutral-200'
            : 'text-warm-500 group-hover:text-neutral-300',
        )}
      >
        360° View
      </p>
    </Component>
  );
};

export default SpinIndicator;
